module.exports = __webpack_public_path__ + "img/hr-tree-05-g-trunk.287027c0.png";